import { jQuery } from './utils/jquery.js';

/**
 * This file will manage js events for single product page
 */


jQuery(function ($) {

    variableProductInstance = {
        variationPriceHtmlEl: $('.js-variation-price-html'),
        addToCartBtnEl: $('.js-custom-variation-add-to-cart-button'),
        productNotAvailableBtnEl: $('.js-custom-variation-product-not-found-button'),
        bookProduct: $('.js-reserve-product-btn'),
        simulateBtn: $('.js-wagt-show-product-request-popup')
    };

    // on click event when custom option select
    $(document).on('click', '.js-woo-custom-attribute-option', function () {
        let selectBoxElId = $(this).attr('data-selected-id');
        let attributeValue = $(this).attr('data-attribute-value');
        let attributeImage = $(this).attr('data-attribute-image');
        // do select data in cart form
        $('#' + selectBoxElId).val(attributeValue).trigger('change');
    });

    $(".variations_form").on("woocommerce_variation_has_changed", function () {
        var availableVariations = [];
        $('.variations').find('select').find('option').each(function() {
            if($(this).val() != '') {
                availableVariations.push($(this).val());
            }
        });

        $('.js-accordion-button-ver-2').each(function(index) {
            var value = $(this).data('attribute-title');
            var $btn = $('[data-attribute-title="'+ value +'"]');
            if($.inArray(value, availableVariations) == -1) {
                $btn.css('opacity', '0.2').prop('disabled', true);
                $btn.prev('.product-options__impossible').show();
            } else {
                $btn.css('opacity', '1').prop('disabled', false);
                $btn.prev('.product-options__impossible').hide();
            }
        });
    });

    $(".variations_form").on("reset_data", function() {
        var $actiOptionsItem = $('.product-options__active-item');
        $actiOptionsItem.find('.js-selected-attribute-name').text('Sélectionnez une option');
        $actiOptionsItem.find('.js-selected-attribute-image').attr('src', $actiOptionsItem.find('.js-selected-attribute-image').data('default-image'));
        $('[data-gallery]').attr('aria-hidden', true);
        $('[data-gallery="default"]').attr('aria-hidden', false);
    });

    if ($('.product-carte').length == 0) {
        $('.variations_form').on('found_variation', function(event, data) {
            var form = (event || {}).currentTarget || null;

            if (!form) {
              return false;
            }

            updateProductGallery(data);
        });
    }

    function updateProductGallery(data) {
        var variationID = data.variation_id;
        $('[data-gallery]').attr('aria-hidden', true);
        $('[data-gallery='+variationID+']').attr('aria-hidden', false);
    }

  // do hide current accordion  when its option is got selected
      $(document).on("click", ".js-accordion-button-ver-2", function () {
        let attributeTitle = $(this).attr("data-attribute-title");
        let attributeImage = $(this).attr("data-attribute-image");

        // hide this dropdown
        $(this).parents(".product-options__items").toggle();
        // change selected attribute name also set selected attribute text
        let selectActiveWrapperEl = $(this)
          .parents(".product-options__items")
          .prev();

        var $select = $('[value="'+attributeTitle+'"]').parents('select');
        $select.val(attributeTitle).trigger('change');

        // change attribute name
        selectActiveWrapperEl
          .find(".js-selected-attribute-name")
          .text(attributeTitle);
        // change attribute image
        selectActiveWrapperEl
          .find(".js-selected-attribute-image")
          .attr("src", attributeImage);

          $(this).parents('.product-options__option').next('[data-quantity]').show()
      });

      var color_left = max_loops;

      if ($('[data-max-loops]').length > 0) {
        var max_loops = parseInt($('[data-max-loops]').data('max-loops'));
        var max_color = parseInt($('[data-max-color]').data('max-color'));

        $('.single_add_to_cart_button').prop('disabled', true);
      }

      if($('[data-quantity]').length > 0) {
        $('[data-quantity]').find('input').on('input', 
            function() {
            setMaxQuantity();
        });
      }

    function setMaxQuantity() {
        var quantity = 0;
        $('[data-quantity]').find('input').each(
            function(index, element) {
                var $element = $(this);
                if (parseInt($element.val()) > parseInt($element.attr('max'))) {
                    $element.val($element.attr('max'));
                }
                if ($element.val()) {
                    quantity += parseInt($element.val());
                }
        });

        color_left = max_loops - quantity;
        $('.color-left').text(color_left);

        if (color_left == 0) {
            $('.js-more-color').hide();
        } 

        $('.single_add_to_cart_button').prop('disabled', color_left != 0);

        if (color_left > 0 && $('.bk-js-accordion.active').length < max_color) {
            $('.js-more-color').show();
        }

        if (quantity <= max_loops && quantity > 0) {
            $('[data-quantity]').find('input').each(
                function(index, element) {
                    var val = $(this).val() == '' ? 0 : parseInt($(this).val());
                    var max = val + parseInt(max_loops - quantity);
                    $(this).attr('max', max);
            });
        }
    }

    $('.js-more-color').on('click', function() {
        $('.bk-js-accordion').each(function(index, element) {
            if($(this).hasClass('active') == false) {
                $(this).addClass('active');
                $(this).show();
                return false;
            }
        });

        if ($('.bk-js-accordion.active').length >= max_color) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });

    $('.single_add_to_cart_button').on('click', function(e) {
        if (color_left > 0) {
            e.preventDefault();
        }
    });

    $(".single_variation_wrap").on("show_variation", function (event, variation) {
        // Fired when the user selects all the required dropdowns / attributes
        // and a final variation is selected / shown
        if (typeof variation != "undefined" && $('.product-carte').length == 0) {
            // do from variation data
            // change price html el
            variableProductInstance.variationPriceHtmlEl.html(variation.price_html);

            variableProductInstance.bookProduct.show();
            variableProductInstance.simulateBtn.show();

            // hide product not available button
            variableProductInstance.productNotAvailableBtnEl.hide();
            // show add to cart button
            variableProductInstance.addToCartBtnEl.show();
        } 
    });
    // on hide or reset variation
    $(".single_variation_wrap").on("hide_variation", function (event) {
        // reset price html
        // hide add to cart button
        variableProductInstance.addToCartBtnEl.hide();
        variableProductInstance.bookProduct.hide();
        variableProductInstance.simulateBtn.hide();
        // show product not available button
        variableProductInstance.productNotAvailableBtnEl.show();
    });

});
